import { render, staticRenderFns } from "./JointPersonalInformation.vue?vue&type=template&id=487e863c"
import script from "./JointPersonalInformation.vue?vue&type=script&lang=js"
export * from "./JointPersonalInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports